export default __webpack_public_path__ + "a4a38b1d1fcd4fe8fddd94b1eadb82e8.svg";